<template>
  <div
    class="punchContainer ig-container"
    v-loading="uLoading"
    element-loading-text="拼命下载中"
  >
    <div class="search-box">
      <div class="label">
        <span>时间</span>
        <el-date-picker
          v-model="oTime"
          class="time"
          size="small"
          type="daterange"
          range-separator="-"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="selectDate"
        >
        </el-date-picker>
      </div>
      <div class="label">
        <span>部门</span>
        <el-select
          class="w-200"
          v-model="search.dept_id"
          size="small"
          multiple
          collapse-tags
          placeholder="请选择"
          @change="teamDetail"
        >
          <el-option
            v-for="item in departList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <!-- <div class="label">
        <span>状态</span>
        <el-select
          v-model="search.is_exception"
          class="w-100"
          size="small"
          placeholder="请选择"
          @change="teamDetail"
        >
          <el-option
            v-for="item in stausList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="label">
        <span>姓名</span>
        <el-input
          class="name"
          v-model="search.name"
          size="small"
          placeholder="请输入姓名"
          @change="teamDetail"
        ></el-input>
      </div>
      <div class="label">
        <span>类型</span>
        <el-select
          v-model="search.type"
          class="w-100"
          size="small"
          placeholder="请选择"
          @change="teamDetail"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="label">
        <span>正常打卡时间</span>
        <el-tag
          v-for="(tag, index) in nomalList"
          size="medium"
          :key="index"
          closable
          type="info"
          effect="plain"
          @close="removeTime('normal', index)"
        >
          {{ tag }}
        </el-tag>
        <p class="btn" v-if="nomalList.length < 4" @click="addTime('normal')">
          +添加
        </p>
      </div>
      <div class="label">
        <span>加班打卡时间</span>
        <el-tag
          v-for="(tag, index) in addList"
          size="medium"
          :key="index"
          closable
          type="info"
          effect="plain"
          @close="removeTime('add', index)"
        >
          {{ tag }}
        </el-tag>
        <p class="btn" v-if="addList.length < 4" @click="addTime('add')">
          +添加
        </p>
      </div>
      <div class="label">
        <el-checkbox v-model="isWeeks">含周末</el-checkbox>
      </div>
      <div class="label">
        <el-button size="small" @click="exportExcel">导出报表</el-button>
        <el-button size="small" @click="backOldPunch">回到旧版</el-button>
      </div>
    </div>
    <div class="table-box">
      <el-table
        id="my-table"
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        size="medium"
        :cell-class-name="isException"
      >
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
          header-align="center"
          width="100"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="deptpath" width="180" label="部门">
        </el-table-column>
        <el-table-column
          prop="empno"
          label="工号"
          width="100"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          prop="postion"
          label="职位"
          width="120"
          align="center"
          header-align="center"
        >
        </el-table-column>
        <el-table-column
          v-for="(item, index) in timeList"
          :label="item.day + '（' + item.week + '）'"
          :prop="item.curDay"
          :key="index"
          width="100"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="card-list">
              <p
                v-for="(day, i) in scope.row[item.curDay]"
                :key="i"
                :class="{
                  isException:
                    item.week == '六' || item.week == '日'
                      ? isWeeks && day == ''
                      : day == '',
                  isRest:
                    day.indexOf('休') != -1 ||
                    day.indexOf('出') != -1 ||
                    day.indexOf('假') != -1,
                }"
              >
                {{ day | timeFormat(item.week == "六" || item.week == "日") }}
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-box">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :page-size="limit"
          :page-sizes="[10, 20, 30, 40, 50]"
          :current-page="page"
          :total="total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加打卡时间段"
      :visible.sync="showTimeSelect"
      width="30%"
      :before-close="handleClose"
    >
      <div class="select-box">
        <el-time-picker
          width="100%"
          is-range
          v-model="startTime"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          format="HH:mm"
          value-format="HH:mm"
        >
        </el-time-picker>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTimeSelect = false">取 消</el-button>
        <el-button
          :disabled="!this.startTime"
          type="primary"
          @click="selectTime"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils/utils'
import api from '@/apis'
let choiceDate0;
let that;
export default {
  data() {
    return {
      uLoading: false,
      loading: true,
      isWeeks: false, //false
      oTime: [],
      total: 0,
      page: 1,
      limit: 10,
      pageSize: [10, 20, 30, 40, 50],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          choiceDate0 = minDate.getTime();
          if (maxDate) {
            choiceDate0 = "";
          }
        },
        disabledDate(time) {
          let choiceDateTime = new Date(choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 1
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 1
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
          if (choiceDate0) {
            return time.getTime() < min || time.getTime() > max;
          }
          //若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
      depart: "",
      search: {},
      departList: [],
      stausList: [
        { label: "全部", value: "0" },
        { label: "正常", value: "1" },
        { label: "异常", value: "2" },
      ],
      typeList: [
        { label: "全部", value: "0" },
        { label: "职工", value: "1" },
        { label: "普工", value: "2" },
      ],
      nomalList: JSON.parse(localStorage.getItem("normalList")) || [
        "00:00-08:05",
        "17:30-23:59",
      ],
      addList: JSON.parse(localStorage.getItem("addList")) || [],
      showTimeSelect: false,
      timeType: "",
      startTime: "",
      endTime: "",
      minTime: "00:00",
      maxTime: "24:00",
      isConnect: false, //是否出现交集
      tableData: [],
      timeList: [],
      testDays: ["日", "一", "二", "三", "四", "五", "六"],
    };
  },
  beforeCreate: function () {
    that = this;
  },
  created() {
    // this.nomalList = ;
    // this.addList = JSON.parse(localStorage.getItem("addList"));
    this.dealDate();
    this.getDepts();
  },
  mounted() {},
  watch: {
    nomalList: {
      handler(newVal) {
        if (newVal.length > 0) {
          localStorage.setItem("normalList", JSON.stringify(newVal));
          setTimeout(() => {
            this.teamDetail();
          }, 1000);
        } else {
          localStorage.removeItem("normalList");
        }
      },
      immediate: true,
    },
    addList: {
      handler(newVal) {
        if (newVal.length > 0) {
          localStorage.setItem("addList", JSON.stringify(newVal));
          setTimeout(() => {
            this.teamDetail();
          }, 1000);
        } else {
          localStorage.removeItem("addList");
        }
      },
      immediate: true,
    },
  },
  filters: {
    timeFormat(e, w) {
      if (
        e.indexOf("休") != -1 ||
        e.indexOf("出") != -1 ||
        e.indexOf("假") != -1
      )
        return e;
      let val = utils.formatDate(
        new Date(e.replace(/-/g, "/")).getTime() / 1000,
        "hh:mm"
      );
      let time = e ? val : "缺卡";

      if (!that.isWeeks && w) {
        time = e ? val : "";
      }
      return time;
    },
  },
  methods: {
    // 返回旧版打卡
    backOldPunch() {
      this.$router.push("/oldPunch");
    },
    //分页
    currentChange(e) {
      this.page = e;
      this.teamDetail();
    },
    //改变每页条数
    handleSizeChange(e) {
      this.limit = e;
      this.teamDetail();
    },
    //禁用日期
    disabledDate(e) {
      return e < new Date();
    },
    //判断是否是异常打卡
    isException({ column }) {
      let property = column.property;
      if (
        property == "name" ||
        property == "empno" ||
        property == "postion" ||
        property == "deptpath"
      ) {
        return "";
      } else {
        return "no-padding";
      }
    },
    //处理时间
    dealDate() {
      let e = new Date().getTime() - 86400000;
      let end = utils.formatDate(e / 1000, "yyyy-MM-dd");
      let s = new Date(end).getTime() - 7 * 86400000;
      let start = utils.formatDate(s / 1000, "yyyy-MM-dd");
      this.oTime = [start, end];
      while (s < e) {
        this.timeList.push({
          day: utils.formatDate(s / 1000, "dd"),
          curDay: utils.formatDate(s / 1000, "yyyy-MM-dd"),
          week: this.testDays[new Date(s).getDay()],
        });
        s += 86400000;
      }
    },

    //选择时间范围
    selectDate(e) {
      this.teamDetail();
      let start = new Date(e[0]).getTime();
      let end = new Date(e[1]).getTime();
      this.timeList = [];
      while (start <= end) {
        this.timeList.push({
          day: utils.formatDate(start / 1000, "dd"),
          curDay: utils.formatDate(start / 1000, "yyyy-MM-dd"),
          week: this.testDays[new Date(start).getDay()],
        });
        start += 86400000;
      }
    },
    // 删除打卡时间段
    removeTime(type, index) {
      switch (type) {
        case "normal":
          this.nomalList.splice(index, 1);
          break;
        case "add":
          this.addList.splice(index, 1);
          break;

        default:
          break;
      }
    },
    // 判断日期是否存在交集
    isDateIntersection(start, end) {
      var startdate1 = new Date("2022/05/20 " + this.startTime[0]);
      var enddate1 = new Date("2022/05/20 " + this.startTime[1]);

      var startdate2 = new Date("2022/05/20 " + start);
      var enddate2 = new Date("2022/05/20 " + end);

      if (startdate1 > startdate2 && startdate1 < enddate2) {
        return true;
      }

      if (enddate1 > startdate2 && enddate1 < enddate2) {
        return true;
      }

      if (startdate1 < startdate2 && enddate1 > enddate2) {
        return true;
      }
      if (startdate1 == startdate2 && enddate1 == enddate2) {
        return true;
      }
      return false;
    },
    // 选择打卡时间段
    selectTime() {
      let arr = [...this.nomalList, ...this.addList];
      try {
        arr.forEach((item) => {
          let start = item.split("-")[0];
          let end = item.split("-")[1];
          this.isConnect = this.isDateIntersection(start, end);
          if (this.isConnect) throw new Error("time-error");
        });
      } catch (error) {
        if (error.message == "time-error") {
          this.isConnect = false;
          return this.$message({
            message: "打卡时间不能出现交集",
            type: "error",
          });
        }
      }
      let str = this.startTime.join("-");
      switch (this.timeType) {
        case "normal":
          if (!this.isConnect) this.nomalList.push(str);
          break;
        case "add":
          if (!this.isConnect) this.addList.push(str);
          break;
        default:
          break;
      }
      this.startTime = "";
      this.showTimeSelect = false;
    },
    // 关闭弹窗
    handleClose() {
      this.shartTime = "";
      this.endTime = "";
    },
    // 添加打卡时间
    addTime(type) {
      this.timeType = type;
      this.showTimeSelect = !this.showTimeSelect;
    },
    // 获取部门
    getDepts() {
      api.getDepts().then((res) => {
        this.departList = res.data;
        // this.teamDetail();
      });
    },
    // 导出表格
    exportExcel() {
      this.uLoading = true;
      let data = {
        start_date: this.oTime[0],
        end_date: this.oTime[1],
        page: this.page,
        limit: this.limit,
      };
      if (this.search) data = { ...data, ...this.search };
      console.log(data);
      if (data.dept_id.length == 0) data.dept_id = this.departList[0].id; //默认
      if (data.dept_id) data.dept_id = data.dept_id.toString();
      let arr = [...this.nomalList, ...this.addList];
      arr.forEach((item, index) => {
        let str = "time_" + (index + 1);
        data[str] = item;
      });
      api.exportData(data).then((res) => {
        this.uLoading = false;
        var iframe = document.createElement("iframe");
        iframe.src = res.data;
        iframe.style.display = "none";
        iframe.onload = function () {
          console.debug("start downloading...");
          document.body.removeAttribute(iframe);
        };
        document.body.appendChild(iframe);
      });
    },
    // 获取考勤详情
    teamDetail() {
      this.loading = true;
      let data = {
        start_date: this.oTime[0],
        end_date: this.oTime[1],
        page: this.page,
        limit: this.limit,
      };
      if (this.search) data = { ...data, ...this.search };
      console.log(data);
      if (data.dept_id.length == 0) data.dept_id = this.departList[0].id; //默认
      if (data.dept_id) data.dept_id = data.dept_id.toString();
      let arr = [...this.nomalList, ...this.addList];
      arr.forEach((item, index) => {
        let str = "time_" + (index + 1);
        data[str] = item;
      });
      api.teamDetail(data).then((res) => {
        this.tableData = res.data.list;
        this.tableData.forEach((person) => {
          person.detail.forEach((item) => {
            person[item.date] = item.kq;
          });
        });
        this.loading = false;
        this.total = parseInt(res.data.pagenums);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ig-container {
  width: 1200px;
  margin: 0 auto;
  .select-box {
    @include flex-center();
    & > div {
      margin: 0 10px;
    }
  }
  .search-box {
    padding: 30px 50px 10px;
    border-bottom: 1px solid #dedede;
    @include flex-start();
    flex-wrap: wrap;
    .label {
      margin-right: 50px;
      margin-bottom: 20px;
      @include flex-start();
      align-items: center;
      & > span {
        font-size: 16px;
        font-family: SimHei;
        font-weight: 400;
        color: #171a1d;
        margin-right: 10px;
      }
      & > div {
        flex: 1;
      }
      .btn {
        font-size: 16px;
        font-family: SimHei;
        font-weight: 400;
        color: #40affc;
        cursor: pointer;
      }
      .w-100 {
        width: 100px;
      }
      .w-200 {
        width: 200px;
      }
      .name {
        width: 140px;
      }
      .time {
        width: 240px;
      }
    }
  }
  .table-box {
    margin-top: 25px;
    .page-box {
      margin-top: 20px;
      @include flex-end();
    }
    &::v-deep .el-table {
      .el-table__cell {
        padding: 4px 0;
      }
      .card-list {
        height: 100%;
        @include flex-center(column);
        & > p {
          width: 100%;
          height: 26px;
          line-height: 26px;
        }
        & > p:not(:last-child) {
          border-bottom: 1px solid #ebeef5;
        }
        & > .isException {
          background: #df301a;
          color: #fff;
        }
        & > .isRest {
          color: #171a1d;
          background: #fe892c;
        }
      }
      .no-padding {
        padding: 0;
        .cell {
          padding: 0;
        }
      }
    }
  }
}
</style>